import { cn } from '../../../lib/utils';
import {
    ADMIN_BADGE_BASE_CLASS,
    ADMIN_BADGE_POSITIVE_CLASS,
    ADMIN_BADGE_NEGATIVE_CLASS,
} from './adminStatusBadge';

export function AdminActiveStatusBadge({
    isActive,
    className,
}: {
    isActive: boolean;
    className?: string;
}) {
    return (
        <span
            className={cn(
                ADMIN_BADGE_BASE_CLASS,
                isActive ? ADMIN_BADGE_POSITIVE_CLASS : ADMIN_BADGE_NEGATIVE_CLASS,
                className,
            )}
        >
            {isActive ? 'Active' : 'Inactive'}
        </span>
    );
}
